module.exports = __webpack_public_path__ + "img/animal_avatar-04.9ec74c86.png";